<template>
  <div class="row" v-if="project" id="breadcrumb" :style="cssProps">
    <div class="col-md-12 col-lg-4">
      <h4 style="color: black;">{{project.workflow.name}}</h4>
      <span class="small">{{project.workflow.description}}</span>
    </div>

    <div class="col-md-12 col-lg-8">
      <div class="row">
        <template v-if="project.workflow_id === 1">
          <div class="col-xs-12 col-sm-6 col-md-3" style="margin-top: 15px" data-toggle="popover" :data-content="helpExploreScience2">
            <router-link v-if="!$user.isBasic()" class="btn btn-info btn-block" id="projectDetails_explore_science"
                         :class="{active: activeStep === 'explore'}"
                         :to="{name: 'Search', params:{project_id: project.id}}">
              Explore Science
            </router-link>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('explore')">Explore Science</button>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-3" style="margin-top: 15px" data-toggle="popover" :data-content="helpExplorePatents">
            <router-link v-if="!$user.isBasic()" class="btn btn-info btn-block" id="projectDetails_explore_patents"
                         :class="{active: activeStep === 'explore'}"
                         :to="{name: 'Search', params:{project_id: project.id}, query: { typeSearched: 1 }}">
              Explore Patents
            </router-link>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('explore')">Explore Patents</button>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-3" style="margin-top: 15px" data-toggle="popover" :data-content="helpExploreEcosystems">
            <router-link v-if="!$user.isBasic()" class="btn btn-info btn-block" id="projectDetails_explore_ecosystems"
                         :class="{active: activeStep === 'explore'}"
                         :to="{name: 'Search', params:{project_id: project.id}, query: { typeSearched: 3 }}">
              Explore Ecosystems
            </router-link>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('explore')"> Explore Ecosystems</button>
          </div>

          <div v-if="show.report" class="col-xs-12 col-sm-6 col-md-3" style="margin-top: 15px" data-toggle="popover" :data-content="!show.protect ? helpReportProtect : helpReport">
            <router-link v-if="enable.report" class="btn btn-info" id="projectDetails_report"
                         style="width: 100%"
                         :class="{active: activeStep === 'report'}"
                         :to="{name: 'ProjectReport', params:{project_id: project.id}}">
              <span v-if="$user.canBlockchain()">Report & protect</span>
              <span v-else>Report</span>
            </router-link>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="explainDisabled('report')" id="projectDetails_report">
              <span v-if="$user.canBlockchain()">Report & protect</span>
              <span v-else>Report</span>
            </button>
          </div>

          <div v-if="show.protect" class="col-xs-12 col-sm-6 col-md-3" style="margin-top: 15px" data-toggle="popover" :data-content="helpProtect">
            <button class="btn btn-info" style="width: 100%" @click="$refs.limitPlan.show('blockchain')" id="projectDetails_protect">Protect</button>
          </div>
        </template>
        <template v-else-if="project.workflow_id === 2">
          <div class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpExploreScience1">
            <router-link v-if="!$user.isBasic()" class="btn btn-info" id="projectDetails_explore"
                         style="width: 100%"
                         :class="{active: activeStep === 'explore'}"
                         :to="{name: 'Search', params:{project_id: project.id}}">
              Explore
            </router-link>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('explore')">Explore</button>
          </div>
          <div v-if="show.question" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpQuestion">
            <router-link v-if="enable.question === 1 && project.question" class="btn btn-info " id="projectDetails_question"
                         style="width: 100%"
                         :class="{active: activeStep === 'question'}"
                         :to="{name: 'QuestionReview', params: {project_id: project.id, question_id: project.question.id}}">
              Question
            </router-link>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="explainDisabled('question')" id="projectDetails_question" title="Create New Question">Question</button>
          </div>
          <div v-if="show.contact" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpContact">
            <router-link v-if="enable.contact" class="btn btn-info " id="projectDetails_contact"
                         style="width: 100%"
                         :class="{active: activeStep === 'contact'}"
                         :to="{name: 'MailingReview', params: {project_id: project.id, question_id: project.question.id}}">
              Contact
            </router-link>
            <template v-else>
              <button v-if="$user.isBasic()" class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('contact')">Contact</button>
              <button v-else class="btn btn-info disabled" style="width: 100%" @click="explainDisabled('contact')" id="projectDetails_contact" >Contact</button>
            </template>
          </div>
          <div v-if="show.interact" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpInteract">
            <router-link v-if="enable.interact" class="btn btn-info " id="projectDetails_interact"
                         style="width: 100%"
                         :class="{active: activeStep === 'interact'}"
                         :to="{name: 'ChatSolution', params: {project_id: project.id, question_id: project.question.id}}">
              Interact
            </router-link>
            <template v-else>
              <button v-if="$user.isBasic()" class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('interact')">Interact</button>
              <button v-else class="btn btn-info disabled" style="width: 100%" @click="explainDisabled('interact')" id="projectDetails_interact">Interact</button>
            </template>
          </div>

          <div v-if="show.report" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="!show.protect ? helpReportProtect : helpReport">
            <router-link v-if="enable.report" class="btn btn-info" id="projectDetails_report"
                         style="width: 100%"
                         :class="{active: activeStep === 'report'}"
                         :to="{name: 'ProjectReport', params:{project_id: project.id}}">
              <span v-if="$user.canBlockchain()">Report & protect</span>
              <span v-else>Report</span>
            </router-link>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="explainDisabled('report')" id="projectDetails_report">
              <span v-if="$user.canBlockchain()">Report & protect</span>
              <span v-else>Report</span>
            </button>
          </div>

          <div v-if="show.protect" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpProtect">
            <button class="btn btn-info" style="width: 100%" @click="$refs.limitPlan.show('blockchain')" id="projectDetails_protect">Protect</button>
          </div>

        </template>
        <template v-else>
          <div v-if="show.question" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpTechTrans">
            <template v-if="!$user.isBasic()">
              <router-link v-if="enable.question && project.question" class="btn btn-info " id="projectDetails_question"
                           style="width: 100%"
                           :class="{active: activeStep === 'question'}"
                           :to="{name: 'QuestionReview', params: {project_id: project.id, question_id: project.question.id}}">
                Tech offer
              </router-link>
              <router-link v-else class="btn btn-info " id="projectDetails_question"
                           style="width: 100%"
                           :class="{active: activeStep === 'question'}"
                           :to="{name: 'QuestionEdit', params:{project_id: project.id}}" title="Create New Question">
                Tech offer
              </router-link>
            </template>
            <template v-else>
              <button v-if="$user.isBasic()" class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('explore')">Tech offer</button>
            </template>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpExploreScienceTechTrans">
            <router-link v-if="!$user.isBasic()" class="btn btn-info" id="projectDetails_explore"
                         style="width: 100%"
                         :class="{active: activeStep === 'explore'}"
                         :to="{name: 'Search', params:{project_id: project.id}}">
              Explore
            </router-link>
            <template v-else>
              <button v-if="$user.isBasic()" class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('explore')">Explore</button>
            </template>
          </div>
          <div v-if="show.contact" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpContact">
            <template v-if="enable.contact">
              <router-link v-if="!$user.isBasic()" class="btn btn-info " id="projectDetails_contact"
                           style="width: 100%"
                           :class="{active: activeStep === 'contact'}"
                           :to="{name: 'MailingReview', params: {project_id: project.id, question_id: project.question.id}}">
                Contact
              </router-link>
              <button v-else class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('contact')">Contact</button>

            </template>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="explainDisabled('contact')" id="projectDetails_contact">Contact</button>
          </div>
          <div v-if="show.interact" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpInteract">

            <template v-if="enable.interact">
              <router-link v-if="!$user.isBasic()" class="btn btn-info " id="projectDetails_interact"
                           style="width: 100%"
                           :class="{active: activeStep === 'interact'}"
                           :to="{name: 'ChatSolution', params: {project_id: project.id, question_id: project.question.id}}">
                Interact
              </router-link>
              <button v-else class="btn btn-info disabled" style="width: 100%" @click="$refs.limitPlan.show('interact')">Interact</button>

            </template>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="explainDisabled('interact')" id="projectDetails_interact">Interact</button>
          </div>

          <div v-if="show.report" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="!show.protect ? helpReportProtect : helpReport">
            <router-link v-if="enable.report" class="btn btn-info" id="projectDetails_report"
                         style="width: 100%"
                         :class="{active: activeStep === 'report'}"
                         :to="{name: 'ProjectReport', params:{project_id: project.id}}">
              <span v-if="$user.canBlockchain()">Report & protect</span>
              <span v-else>Report</span>
            </router-link>
            <button v-else class="btn btn-info disabled" style="width: 100%" @click="explainDisabled('report')" id="projectDetails_report">
              <span v-if="$user.canBlockchain()">Report & protect</span>
              <span v-else>Report</span>
            </button>
          </div>

          <div v-if="show.protect" class="col-xs-12 col-sm-6 col-md-2" style="margin-top: 15px" data-toggle="popover" :data-content="helpProtect">
            <button class="btn btn-info" style="width: 100%" @click="$refs.limitPlan.show('blockchain')" id="projectDetails_protect">Protect</button>
          </div>
        </template>

      </div>
    </div>

    <limit-plan ref="limitPlan"></limit-plan>

    <div class="modal fade" id="modalProjectDetailsAccessDisabled" tabindex="-1" role="dialog"  aria-hidden="true">
      <div  class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Access disabled</h4>
            </div>
            <div class="modal-body">
              <template v-if="project && project.workflow_id === 1">
                <template v-if="targetExplainDisabled === 'report'">
                  <div>The project needs to contain at least one element (saved document or selected expert/company), then you can create your report.</div>
                </template>
              </template>
                <template v-else-if="project && project.workflow_id === 2">
                  <template v-if="targetExplainDisabled === 'question'">
                    <div>A draft of question needs to be created first, by clicking on the 'Create question' button just down in the question part of this page.</div>
                    <div>You can then access, edit and validate your question.</div>
                  </template>
                  <template v-else-if="targetExplainDisabled === 'contact'">
                    <div>Your question needs to be validated first. You can then prepare and manage emails to experts.</div>
                  </template>
                  <template v-else-if="targetExplainDisabled === 'interact'">
                    <div>A mailing needs to be created first, you can then interact with the contacted experts.</div>
                  </template>
                  <template v-else-if="targetExplainDisabled === 'report'">
                    <div>The project needs to contain at least one element (question, saved document or selected expert/company), then you can create your report.</div>
                  </template>
                </template>
                <template v-if="project && project.workflow_id === 3">
                  <template v-if="targetExplainDisabled === 'contact'">
                    <div>Your Tech offer needs to be validated first. You can then prepare and manage emails to experts.</div>
                  </template>
                  <template v-else-if="targetExplainDisabled === 'interact'">
                    <div>A mailing needs to be created first, you can then interact with the contacted experts.</div>
                  </template>
                  <template v-else-if="targetExplainDisabled === 'report'">
                    <div>The project needs to contain at least one element (question, document or expert/company), then you can create your report.</div>
                  </template>
                </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" >Close</button>
            </div>
          </div>
      </div>
    </div>

  </div>
</template>

<style scoped>

  button:disabled {
    color: #a7dcff;
  }

  @media (min-width: 992px) {
    #breadcrumb .col-md-2 {
      width: var(--col-md-2);
    }
  }

  @media (min-width: 992px) {
    #breadcrumb .col-md-3 {
      width: var(--col-md-3);
    }
  }

</style>

<script>

import { helpExploreScience1, helpExploreScience2, helpExploreScienceTechTrans, helpExplorePatents, helpExploreEcosystems, helpQuestion,
  helpInteract, helpContact, helpReport, helpReportProtect, helpProtect, helpTechTrans} from '../tour/ProjectDetailsTour'
import LimitPlan from '../../components/LimitPlan'

export default {
  components: {LimitPlan},
  props: ['activeStep', 'projectId'],
  name: 'BreadcrumbBox',
  data () {
    return {
      helpExploreScience1,
      helpExploreScience2,
      helpExploreScienceTechTrans,
      helpExplorePatents,
      helpExploreEcosystems,
      helpQuestion,
      helpInteract,
      helpContact,
      helpReport,
      helpReportProtect,
      helpProtect,
      helpTechTrans,
      project: null,
      show: {
        explore: 1,
        question: 0,
        contact: 0,
        interact: 0,
        report: 1,
        protect: 1
      },
      enable: {
        explore: 0,
        question: 0,
        contact: 0,
        interact: 0,
        report: 0,
        protect: 1
      },
      refresh: null,
      listIdSelected: null,
      biblioId: null,
      nbExperts: 0,
      nbBiblioBox: 0,
      targetExplainDisabled: null
    }
  },
  computed: {
    cssProps () {
      return {
        '--col-md-2': this.show.protect ? '16.66666667%' : '20%',
        '--col-md-3': this.show.protect ? '20%' : '25%'
      }
    }
  },
  watch: {
    refresh: function () {
      if (this.refresh) {
        this.getResources()
      }
    }
  },
  methods: {
    getResources () {
      this.axios.get('/project/' + this.projectId + '?relations={portfolio,workflow,question,lists,lists.biblio,' +
          'lists.listAuthors,owner,question.consultant,question.mailing}')
        .then((response) => {
          this.project = response.data
          this.updateBreadcrumb()
          this.refresh = false
        }).catch(function (error) {
        })
    },
    updateBreadcrumb: function () {
      this.enable.explore = 1
      if (this.project !== null) {
        this.getListBiblioIdSelected()
        if (this.project.workflow_id !== 1) {
          this.show.question = 1
          this.show.contact = 1
          this.show.report = 1
          this.show.interact = 1
          if (this.project.question !== null || this.nbBiblioBox !== 0) {
            this.enable.question = 1
            if (this.project.question !== null && this.project.question.status_id >= 3 && this.project.lists.length !== 0) {
              this.enable.contact = 1

              if (this.project.question.mailing !== null && this.project.question.mailing.length !== 0) {
                this.enable.interact = 1
              }
            }
          }
        }

        if (this.project.question !== null || (this.biblioId && this.nbBiblioBox !== 0) || this.nbExperts !== 0) {
          this.enable.report = 1
        }
      }

      this.show.protect = !this.$user.canBlockchain()
    },
    getListBiblioIdSelected: function (listId) {
      let listIdSelected = listId || parseInt(localStorage.getItem('listIdSelected'))

      if (this.project && this.project.lists && this.project.lists.length !== 0) {
        let listSelected = this.project.lists.find((list) => {
          return list.id === listIdSelected
        })
        this.listIdSelected = listSelected ? listSelected.id : this.project.lists[0].id

        if (listSelected && listSelected.biblio.length !== 0) {
          this.biblioId = listSelected.biblio[0].id

          if (typeof listSelected.biblio[0].content !== 'undefined') {
            let content = JSON.parse(listSelected.biblio[0].content)
            this.nbBiblioBox = Object.keys(content).length
          }
        }

        if (listSelected && listSelected.list_authors && listSelected.list_authors.length !== 0) {
          this.nbExperts = listSelected.list_authors.length
        }
      } else {
        this.listIdSelected = null
        this.biblioId = null
        this.nbExperts = 0
        this.nbBiblioBox = 0
      }
    },
    explainDisabled: function (target) {
      this.targetExplainDisabled = target
      $('#modalProjectDetailsAccessDisabled').modal('show')
    }
  },
  beforeMount () {
    this.$eventHub.$on('listIdSelected', (listId) => {
      this.getListBiblioIdSelected(listId)
    })
    this.getResources()
  },
  beforeDestroy () {
    this.$eventHub.$off('listIdSelected')
  },
  updated () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      html: true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/BreadcrumbBox.vue